import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-eye",
  "use": "foquz-icon-eye-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol viewBox=\"0 0 18 12\" fill=\"none\" id=\"foquz-icon-eye\"><path d=\"M1 6s2.91-5 8-5 8 5 8 5-2.91 5-8 5-8-5-8-5z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M9 8a2.182 2.182 0 100-4.364A2.182 2.182 0 009 8z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol